export default "__VITE_ASSET__KkWbRfZr__"